"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CuratedTicketEmbeddedWidgetDataSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
var CommonResponseItemBenefitDto = common_1.CommonResponseItemPropertyDto.extend({
    description: zod_1.z.string().nullish(),
});
var CuratedTicketCategorySchema = zod_1.z.object({
    icon: zod_1.z.string(),
    title: zod_1.z.string(),
    action: common_1.CommonResponseItemActionDto,
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
});
var CuratedTicketItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    action: common_1.CommonResponseItemActionDto,
    image: zod_1.z.object({
        width: zod_1.z.number(),
        height: zod_1.z.number(),
        unit: zod_1.z.enum(['FLEXIBLE', 'FIXED']),
        url: zod_1.z.string(), // 이미지 링크
    }),
    position: zod_1.z
        .object({
        latitude: zod_1.z.number(),
        longitude: zod_1.z.number(),
    })
        .nullable(),
    discountBadge: common_1.CommonResponseItemPropertyDto.nullable(),
    locationDescription: common_1.CommonResponseItemPropertyDto.nullable(),
    ranking: common_1.CommonResponseItemPropertyDto.nullable(),
    memberClassBadge: common_1.CommonResponseItemPropertyDto.nullable(),
    review: common_1.CommonResponseItemReviewDto.nullable(),
    caption: zod_1.z
        .object({
        title: zod_1.z.string(),
        badge: zod_1.z.string().nullable(),
    })
        .nullable(),
    badges: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
    title: common_1.CommonResponseItemPropertyDto,
    description: common_1.CommonResponseItemPropertyDto.nullable(),
    location: common_1.CommonResponseItemPropertyDto.nullable(),
    benefits: zod_1.z.array(CommonResponseItemBenefitDto),
    availableQuantity: CommonResponseItemBenefitDto.nullable(),
    features: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
    prices: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
    notices: zod_1.z.array(CommonResponseItemBenefitDto),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
});
/**
 * [V1] 임베디드 티켓 큐레이션 - 응답 스키마 (YDM__NOL_CURATED_TICKET_EMBEDDED__V1, v9.15.0~)
 *
 * @see {@link https://fe-api-doc.dev.yanolja.in/?api=cx-display-api#tag/Widget/paths/~1widget~1v1~1curated-ticket-embedded/get}
 */
exports.CuratedTicketEmbeddedWidgetDataSchema = zod_1.z.object({
    header: zod_1.z.object({
        logoUrl: zod_1.z.string(),
        action: common_1.CommonResponseItemActionDto,
        serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
    }),
    categories: zod_1.z.array(CuratedTicketCategorySchema),
    items: zod_1.z.array(CuratedTicketItemSchema),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
});
